import React, { useState } from "react";
import { object, string, bool } from "prop-types";
import CardImage from "../card-image";
import LightBoxImage from "../../molecules/lightBox-image";
import "./column-img.m.css";


const ColumnImg = ({ story, isHeroImage = true }) => {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = (isPopupOpen) => {
    setShowPopup(isPopupOpen);
  }

  const imgS3keys = story["hero-image-s3-key"];

  return (
    <div styleName="wrapper">

      {isHeroImage && (
        <React.Fragment>
          {imgS3keys && <div styleName="card-img" onClick={() => { togglePopup(true) }}>
            <CardImage
              story={story}
              defaultWidth={259}
              aspectRatio={[1, 1]}
              imageType="image1x1"
              widths={[250, 375]}
            />
          </div>}
          {showPopup && (
            <LightBoxImage
              story={story}
              closePopup={() => togglePopup()}
              isHeroImage={true}
            />
          )}
          {(story["hero-image-caption"] || story["hero-image-attribution"]) && (
            <div styleName="hero-image-wrapper">
              {story["hero-image-caption"] && (
                <figcaption styleName="image-caption" className="story-element-image-title">
                  {story["hero-image-caption"]}
                </figcaption>
              )}
              {story["hero-image-attribution"] && (
                <figcaption className="story-element-image-title">Kuva: {story["hero-image-attribution"]}</figcaption>
              )}
            </div>
          )}
        </React.Fragment>
      )}

    </div>
  );
};

ColumnImg.propTypes = {
  story: object,
  sectionName: string,
  isHeroImage: bool
};

export default ColumnImg;
